module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/882f2ceb4ee5da69b7ed77410b735c25.png";